import subscriptionKeys from './subscriptionKeys'

export default {
  menuButton: 'reminder.menu.button',
  email: {
    subject: 'reminder.email.subject',
    body: 'reminder.email.body',
  },
  modal: {
    header: 'reminder.modal.header',
    footer: {
      send: 'Send',
      cancel: 'Cancel',
    },
  },
  notifications: {
    sent: 'reminder.sent.ok',
    notSent: 'reminder.sent.fail',
    updateFailed: 'reminder.update_failed',
    updateSuccess: 'reminder.update_success',
    post: {
      sent: 'notifications.invoice.send.success',
      notSent: 'apix.ApixSendError',
    },
  },
  myReminder: {
    header: 'reminder.my_account_view_header',
    emailHeader: 'reminder.my_account_view_headerEmail',
    postHeader: 'reminder.my_account_view_headerPost',
    infoTitle: 'reminder.my_account_view_info_title',
    infoText: 'reminder.my_account_view_info_text',
    activatePlan: 'reminder.activate_plan',
    active: 'reminder.active',
    beforeDueDateTitle: 'reminder.before_due_date_title',
    beforeDueDateText: 'reminder.before_due_date_text',
    onDueDateTitle: 'reminder.on_due_date_title',
    onDueDateText: 'reminder.on_due_date_text',
    afterDueDateTitle: 'reminder.after_due_date_title',
    afterDueDateText: 'reminder.after_due_date_text',
    postAfterDueDateTitle: 'reminder.post_after_due_date_title',
    postAfterDueDateText: 'reminder.post_after_due_date_text',
    createNotifications: 'reminder.create_notifications',
    sendRemindersDate: 'reminder.send_reminders_date',
    premiumFeature: 'reminder.premium_feature',
    upgradeModalTitle: 'reminder.upgrade_title',
    cancelUpgrade: 'reminder.upgrade_cancel',
  },
  edit: {
    title: 'reminder.edit_title',
    active: 'reminder.active',
    beforeDueDateTitle: 'reminder.edit_before_due_date_title',
    onDueDateTitle: 'reminder.edit_on_due_date_title',
    afterDueDateTitle: 'reminder.edit_after_due_date_title',
    postAfterDueDateTitle: 'reminder.edit_post_after_due_date_title',
    send: {
      label: 'reminder.edit_send_label',
      onDueDate: 'reminder.edit_send_on_due_date',
      beforeDueDate: 'reminder.edit_send_before_due_date',
      afterDueDate: 'reminder.edit_send_after_due_date',
      postAfterDueDate: 'reminder.edit_send_post_after_due_date',
    },
    subject: {
      label: 'reminder.edit_subject_label',
      example: 'reminder.edit_subject_example',
      suffix: 'reminder.edit_subject_suffix',
    },
    coverLetter: {
      title: 'reminder.edit_cover_letter.title',
      letter: 'reminder.edit_cover_letter.letter',
    },
    message: {
      label: 'reminder.edit_message_label',
      placeholder: 'reminder.edit_message_placeholder',
    },
    interval: {
      once: 'reminder.interval_once',
      every: 'reminder.interval_every',
    },
    note: {
      post: {
        title: 'reminder.edit_note_post_title',
        text: 'reminder.edit_note_post_text',
      },
    },
    premiumCTA: 'reminder.premium-cta',
  },
  settings: {
    onDueDateSubject: 'reminder.default_on_due_date_subject',
    beforeDueDateSubject: 'reminder.default_before_due_date_subject',
    afterDueDateSubject: 'reminder.default_after_due_date_subject',
    postAfterDueDateTitle: 'reminder.default_post_after_due_date_title',
    onDueDateBody: 'reminder.default_on_due_date_body',
    beforeDueDateBody: 'reminder.default_before_due_date_body',
    afterDueDateBody: 'reminder.default_after_due_date_body',
    postAfterDueDateLetter: 'reminder.default_post_after_due_date_letter',
  },
  postModal: {
    header: 'reminder.post.modal.header',
    info: 'reminder.post.modal.info',
    content: {
      coverHeader: 'reminder.post.modal.content.cover_header',
      coverLabel: 'reminder.post.modal.content.cover_label',
      coverLetter: 'reminder.post.modal.content.cover_letter',
      contactDetails: 'ContactDetails',
      companyName: 'CompanyName',
      firstName: 'FirstName',
      lastName: 'LastName',
      invoiceDetails: 'InvoicingAddress',
      address: 'Address',
      postCode: 'PostalCode',
      city: 'City',
      country: 'Country',
    },
    plan: {
      quotaLeft: subscriptionKeys.quotaLeft,
      header: 'reminder.post.modal.plan.header',
      info: 'reminder.post.modal.plan.info',
    },
    footer: {
      send: 'Send',
      cancel: 'Cancel',
    },
  },
}
